module.exports = __webpack_public_path__ + "img/capa1.f61a8e77.webp";